import gql from "graphql-tag";

export const UpdateVeriflytAccountMutation = gql`
    mutation VeriflytRegisterer_UpdateVeriflytAccount($entityID: ID!, $veriflytID: ID){
        VeriflytUpdateAccount(entityID: $entityID, veriflytID: $veriflytID){
            ... on Person {
                _id
                veriflytID
            }
        }
    }
`